import { Text, View } from "@react-pdf/renderer";
import { CategoryType } from "../../../../../../../actions/Tenants/config/constantsTyped";
import { ColorCodedVector } from "../../../../../Helper/ColorCodedSpan";
import { styles } from "./PDFLayerMeta.styles";

interface PDFLayerMetaProps {
    fields: any[];
    status?: string;
    categories?: CategoryType[]
}

export const PDFLayerMeta = ({
    fields,
    status,
    categories,
}: PDFLayerMetaProps) => {
    return (
        <View style={styles.container}>

            <View style={styles.metaItemContainer}>
                {fields.map((i, index) => (
                    <View key={index} style={styles.metaItemsIntakeReport}>
                        <View style={{ flex: 1 }}>
                            <Text>{i.label}:</Text>
                        </View>

                        <View>
                            <Text style={status ? styles.metaTextValueIntakeReport : styles.metaTextValue}>
                                {i.display_vector(9)}
                            </Text>
                        </View>
                    </View>
                ))}
            </View>

            {status && (
                <View style={styles.itemOveralDecision}>
                    <Text style={{ fontSize: 12 }}>Overall decision:</Text>

                    <View>
                        <ColorCodedVector variant={categories ? "badge" : "swatch" } flag={categories?.find((c) => c.value === status)?.color ?? status}>
                            {categories?.find((c) => c.value === status)?.label ?? status}
                        </ColorCodedVector>
                    </View>
                </View>
            )}
        </View>
    );
};
